module.exports = __webpack_public_path__ + "img/falmata-bulama-1711993L.63d540df.jpg";